import request from "@/utils/request";

// 获取区域分页树
export function queryLocationTree() {
  return request({
    url: "/opArea/selectTree",
    method: "post",
    data: {},
  });
}

// 新增
export function insertLocation(data) {
  return request({
    url: "/opArea/save",
    method: "post",
    data,
  });
}

// 修改
export function updateLocation(data) {
  return request({
    url: "/opArea/update",
    method: "post",
    data,
  });
}

// 通过id查询详情
export function queryLocationById(id) {
  return request({
    url: `/opArea/${id}`,
    method: "get",
  });
}

// 删除
export function deleteLocationById(id) {
  return request({
    url: `/opArea/delete/${id}`,
    method: "delete",
  });
}
